const YahariReview = {
    id: 1,
    
      title: "Yahari Ore no Seishun Love Comedy wa Machigatteiru ",
      date: "September 20, 2024",
      sections: [
        {

          heading: "My Teen Romantic Comedy SNAFU",
          
          content: `Different kind of high school story,  Some anime show you the bright, fun side of high school, but My Teen Romantic Comedy SNAFU takes a different route. It gives you something quieter, more introspective, and raw. You meet Hachiman Hikigaya a loner, a cynic, someone who sees the world for what it is and doesn’t try to sugarcoat it. Right from the start, you feel like this isn’t 
          going to be about typical romantic
           clichés or over the-top comedy.
 sharp, brutally honest, and deeply flawed,
 
 not trying to be the hero; he’s just trying to survive high school
  on his own terms, even if it means pushing people away.`,
        },
        {
            preHeadingImages: [
                require("../BlogAssets/images/yahari/the2.png"),
                require("../BlogAssets/images/yahari/the2whisper.jpg"),
              ], // Two photos side by side before the "Review" headin

          heading: "The Volunteer Service Club: Where It All Starts",
          content: `A small group where Hachiman, Yukino Yukinoshita
          , and Yui Yuigahama come together to solve other students' problems..

             however, the way in which OreGairu tackles them, engages audience
              of all ages. The majority of anime with younger characters tend
    

            Though, that is not to say OreGairu has no faults,.`,
        },
        {
          heading: "",
          content: `One of the struggles, is how posters and promotional materials can 
          sometimes keep you away from trying a show, the poster might seem like just ehh
      .`,


      preHeadingImages: [
        require("../BlogAssets/images/yahari/00a128d.webp"),
        require("../BlogAssets/images/yahari/vacation.jpg"),
      ], // Two photos side by side before the "Review" headin

        },
      ],
      tags: ["Anime", "Comedy", "Romance"],

      images: [
        require("../BlogAssets/images/yahari/yahari-ore-no-seish.jpg"),
        require("../BlogAssets/images/yahari/club.jpg"),
        require("../BlogAssets/images/yahari/thee2.jpg"),

    ],
  };
  
  export default YahariReview;
  